const PARTNER_STATUS_FAAS = ['REQUESTED', 'ACTIVE', 'CANCELLED', 'CANREQUESTED', 'REJECTED'];
const PARTNER_STATUS_FFB = ['ACTIVE', 'CANCELLED', 'ONHOLD'];

const ORGANIZATION_TYPE = ['SERVICE', 'BUSINESS'];

export { PARTNER_STATUS_FAAS, PARTNER_STATUS_FFB, ORGANIZATION_TYPE };
